function state() {
  return {
    additionalFeeRequest: {},
    additionalFeeRequestList: [],
    additionalFeeRequestMeta: {},
  };
}

export default state;
